import { makeUseQueryHook } from '@graphql/functions'
import { EMPTY_SECTION_OF_THUMBNAILS } from '@graphql/placeholders'
import { GetSectionOfThumbnailsDocument } from '@graphql/queries/GetSectionOfThumbnails.graphql'
import { usePersonalizations } from '@lib/hooks/usePersonalizations'
import { renderTemplate } from '@lib/utils/text'
import { produce } from 'immer'

/**
 * Returns the personalized content for a section.
 */
export const useSectionOfThumbnails = (id: string) => {
    const personalizations = usePersonalizations()
    const result = useGetSectionOfThumbnails({ variables: { id } })

    const section = produce(
        result.data?.section ?? EMPTY_SECTION_OF_THUMBNAILS,
        (draft) => {
            const { section } = draft

            if (section) {
                section.title = renderTemplate(section.title, personalizations)
                section.subtitle = renderTemplate(
                    section.subtitle,
                    personalizations,
                )
            }
        },
    )

    return { section, ...result }
}

const useGetSectionOfThumbnails = makeUseQueryHook({
    query: GetSectionOfThumbnailsDocument,
})
